import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl-next';
import Popup from '@atlaskit/popup';
import { Box, Inline, Pressable, Flex, xcss } from '@atlaskit/primitives';
import Button from '@atlaskit/button/new';
import Tooltip from '@atlaskit/tooltip';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import { Reaction } from '../Reaction';
import { ReactionSummaryButton } from './ReactionSummaryButton';
import { messages } from '../../shared/i18n';
var summaryPopupStyles = xcss({
  padding: 'space.100',
  paddingTop: 'space.050',
  maxWidth: '325px'
});
var viewAllButtonStyling = xcss({
  marginTop: 'space.050'
});
var iconStyle = xcss({
  height: '20px'
});

/**
 * Test id for the Reactions summary view popup
 */
export var RENDER_SUMMARY_VIEW_POPUP_TESTID = 'render-summary-view-popup';
export var ReactionSummaryView = function ReactionSummaryView(_ref) {
  var emojiProvider = _ref.emojiProvider,
    _ref$reactions = _ref.reactions,
    reactions = _ref$reactions === void 0 ? [] : _ref$reactions,
    _ref$flash = _ref.flash,
    flash = _ref$flash === void 0 ? {} : _ref$flash,
    _ref$particleEffectBy = _ref.particleEffectByEmoji,
    particleEffectByEmoji = _ref$particleEffectBy === void 0 ? {} : _ref$particleEffectBy,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'auto-start' : _ref$placement,
    onReactionClick = _ref.onReactionClick,
    onReactionFocused = _ref.onReactionFocused,
    onReactionMouseEnter = _ref.onReactionMouseEnter,
    _ref$showOpaqueBackgr = _ref.showOpaqueBackground,
    showOpaqueBackground = _ref$showOpaqueBackgr === void 0 ? false : _ref$showOpaqueBackgr,
    _ref$subtleReactionsS = _ref.subtleReactionsSummaryAndPicker,
    subtleReactionsSummaryAndPicker = _ref$subtleReactionsS === void 0 ? false : _ref$subtleReactionsS,
    handleOpenReactionsDialog = _ref.handleOpenReactionsDialog,
    allowUserDialog = _ref.allowUserDialog;
  var intl = useIntl();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSummaryPopupOpen = _useState2[0],
    setSummaryPopupOpen = _useState2[1];
  var handlePopupClose = useCallback(function () {
    return setSummaryPopupOpen(false);
  }, []);
  var handleSummaryClick = useCallback(function () {
    return setSummaryPopupOpen(!isSummaryPopupOpen);
  }, [isSummaryPopupOpen]);
  return /*#__PURE__*/React.createElement(Popup, {
    placement: placement,
    content: function content() {
      return /*#__PURE__*/React.createElement(Inline, {
        xcss: summaryPopupStyles,
        testId: RENDER_SUMMARY_VIEW_POPUP_TESTID,
        space: "space.025",
        shouldWrap: true,
        alignBlock: "center"
      }, reactions.map(function (reaction) {
        return /*#__PURE__*/React.createElement(Reaction, {
          key: reaction.emojiId,
          reaction: reaction,
          emojiProvider: emojiProvider,
          onClick: onReactionClick,
          onFocused: onReactionFocused,
          onMouseEnter: onReactionMouseEnter,
          flash: flash[reaction.emojiId],
          showParticleEffect: particleEffectByEmoji[reaction.emojiId]
        });
      }), allowUserDialog && /*#__PURE__*/React.createElement(Box, {
        xcss: viewAllButtonStyling
      }, /*#__PURE__*/React.createElement(Pressable, {
        backgroundColor: "color.background.neutral.subtle",
        padding: "space.0"
      }, /*#__PURE__*/React.createElement(Tooltip, {
        content: intl.formatMessage(messages.seeWhoReactedTooltip)
      }, function (tooltipProps) {
        return /*#__PURE__*/React.createElement(Button, _extends({}, tooltipProps, {
          spacing: "compact",
          onClick: function onClick() {
            handlePopupClose();
            handleOpenReactionsDialog === null || handleOpenReactionsDialog === void 0 || handleOpenReactionsDialog(reactions[0].emojiId);
          }
        }), /*#__PURE__*/React.createElement(Flex, {
          alignItems: "center",
          xcss: iconStyle
        }, /*#__PURE__*/React.createElement(ShowMoreHorizontalIcon, {
          label: intl.formatMessage(messages.seeWhoReacted)
        })));
      }))));
    },
    isOpen: isSummaryPopupOpen,
    onClose: handlePopupClose,
    trigger: function trigger(triggerProps) {
      return /*#__PURE__*/React.createElement(ReactionSummaryButton, _extends({}, triggerProps, {
        emojiProvider: emojiProvider,
        reactions: reactions,
        onClick: handleSummaryClick,
        showOpaqueBackground: showOpaqueBackground,
        subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker
      }));
    }
  });
};